import { OrderStatus } from '@src/orders/domain/Order';
import { OrderTab } from '@src/orders/domain/OrderTab';
import { useOrdersWithFilters } from '@src/orders/hooks/useOrdersWithFilters';

export const useGetNewOrdersForBillToClient = (
  clientId: string,
  enabled?: boolean,
) => {
  const { orders, isLoading } = useOrdersWithFilters({
    billToClientId: clientId,
    assignedToMe: false,
    page: 1,
    pageSize: 1,
    category: OrderTab.New,
    status: OrderStatus.NEW,
    enabled,
  });

  return {
    hasNewOrdersForBillToClient: orders.totalOrders > 0,
    newOrdersForBillToClientCount: orders.totalOrders,
    isLoading,
  };
};
